import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  currentStep: 0,
  totalSteps: 0,
}

export const { actions: stepperActions, reducer: stepperReducer } = createSlice({
  name: '@app/stepper',
  initialState,
  reducers: {
    setTotalSteps: (state, action) => {
      state.totalSteps = action.payload
    },
    nextStep: (state) => {
      if (state.currentStep < state.totalSteps - 1) {
        state.currentStep += 1
      }
    },
    previousStep: (state) => {
      if (state.currentStep > 0) {
        state.currentStep -= 1
      }
    },
    goToStep: (state, action) => {
      const step = action.payload
      if (step >= 0 && step < state.totalSteps) {
        state.currentStep = step
      }
    },
    reset: () => initialState,
  },
})
